import {
  createGetAllMethod,
  createPutMethod,
} from '../core/factory';
import {entityType} from "./module";

export const getMyProfile = () => createGetAllMethod(entityType)
export const updateMyProfile = (payload) => createPutMethod(entityType, payload)
